<template>
  <div>
    <div class="jumbotron main-hero">
      <div class="container">
        <h1>Unidos por un solo objetivo:<br />el Talmud</h1>
        <h5 class="font-weight-light">
          Jabrutouch es la mayor comunidad online de estudio del Talmud en
          español. Descubre y únete al proyecto que transforma miles de vidas
          judías.
        </h5>
        <div id="map">
          <video autoplay muted loop id="video">
            <source
              :src="require('../assets/images/solidmap-mp4.mp4')"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="counts">
          <div class="counts-row">
            Usuarios activos
            <div class="number">{{ active }}</div>
          </div>
          <div class="counts-row">
            Shiurim estudiados
            <div class="number">{{ shiurim }}</div>
          </div>
          <div class="counts-row">
            Clases online
            <div class="number">{{ 4000 }}+</div>
          </div>
          <div class="counts-row">
            Países <span class="hide-mobile">en 4 continentes</span>
            <div class="number">30</div>
          </div>
          <div
            class="counts-img text-center d-none d-sm-block"
            :style="{
              backgroundImage:
                'url(' + require('../assets/images/circleestudiando.gif') + ')',
            }"
          >
            <div class="learning-now">
              {{ online }}
            </div>

            <div class="learning-now-label">Estudiando en este momento</div>
          </div>
        </div>
      </div>
    </div>
    <bottom-shape :background="'#4544c2'"></bottom-shape>
    <div
      class="counts-img text-center d-sm-none d-block"
      :style="{
        backgroundImage:
          'url(' + require('../assets/images/circleestudiando.gif') + ')',
      }"
    >
      <div class="learning-now">
        {{ online }}
      </div>

      <div class="learning-now-label">Estudiando en este momento</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      online: 0,
      shiurim: 0,
    };
  },
  mounted() {
    var date1 = new Date("01/06/2020");
    var date2 = new Date();
    var Difference_In_Time = date2.getTime() - date1.getTime();
    // this.active = Math.ceil(6000 + (Difference_In_Time / (1000 * 3600 * 24)))
    this.active = "6.000+";
    // this.shiurim = Math.ceil(28000000 + (Difference_In_Time / (1000 * 1200)))
    this.shiurim = "2.800.400+";
    setInterval(function () {
      this.shiurim = Math.ceil(28000000 + Difference_In_Time / (1000 * 1200));
    }, 10000);

    let self = this;
    self.online = Math.floor(Math.random() * (370 - 390 + 1) + 390);
    setInterval(function () {
      self.online = Math.floor(Math.random() * (370 - 390 + 1) + 390);
    }, 10000);
  },
  methods: {},
};
</script>
<style lang="scss">
.jumbotron.main-hero {
  background: #4544c2;
  color: #fff;
  border-radius: 0;
  margin-bottom: 0;
}
.jumbotron {
  margin-bottom: 0 !important;
}
#map {
  margin: 0 0 170px 0;
  width: 100%;
  position: relative;
  #video {
    position: relative;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
.counts {
  right: 0;
  bottom: 0;
  position: relative;
}
.counts-img {
  bottom: 0;
  right: 0;
  width: 276px;
  height: 283px;
  background-repeat: no-repeat;
  background-position: center;
  color: #000;
  padding: 50px;
  position: absolute;
  border: 2px solid #fff;
  border-radius: 50%;
}
.counts-row {
  background: #59c3c3;
  border-radius: 2px;
  right: 130px;
  position: absolute;
  bottom: 100px;
  width: 420px;
  line-height: 60px;
  font-size: 24px;
  padding: 0 30px;
  font-weight: 400;
}
.learning-now {
  font-weight: bold;
  font-size: 70px;
  line-height: 100px;
}
.learning-now-label {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
}
.counts-row:first-child {
  bottom: 210px;
}
.counts-row:nth-child(2) {
  bottom: 140px;
}
.counts-row:nth-child(3) {
  bottom: 70px;
}
.counts-row:nth-child(4) {
  bottom: 0px;
}
.number {
  position: absolute;
  right: 400px;
  bottom: 0;
  background: #ff5f50;
  border-radius: 10px;
  padding: 0 20px;
  font-weight: bold;
  font-size: 45px;
}
.navbar-dark .navbar-nav .nav-link a {
  color: #fff;
}
@media only screen and (max-width: 900px) {
  #map {
    margin: 0;
  }
  .counts-row {
    padding-left: 20px;
    position: relative;
    width: 65%;
    right: -45%;
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 40px;
    bottom: initial !important;
    padding-right: 0;
  }
  .number {
    right: calc(100% - 10px);
    font-size: 24px;
    padding: 0 15px;
  }
  .counts-img {
    position: relative;
    margin: auto;
  }
  .hide-mobile {
    display: none;
  }
}
</style>